import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'qmReplace'
})
export class QmReplacePipe implements PipeTransform {

  transform(text: string, translateArr: {key: string, value: string}[]): string {
    if (translateArr && translateArr.length > 0) {
      for (const single of translateArr) {
        text = text.replace(single.key, single.value);
      }
    }
    return text;
  }

}
